<template>
    <input v-model="inner"
           type="text"
           @paste="onPasteUrl"
           placeholder="Введите ссылку вида https://..."
    />
</template>

<script>
import { toUnicode } from 'punycode';

export default {
    props: {
        value: {
            type: String,
        },
    },
    computed: {
        inner: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        onPasteUrl(event) {
            event.preventDefault();

            const clipboardData = event.clipboardData || window.clipboardData;
            const source = clipboardData.getData('text');

            try {
                const url = new URL(source);
                const decodedHostname = toUnicode(url.hostname);
                this.inner = source.replace(url.hostname, decodedHostname);
            } catch (e) {
                console.error(e);
            }
        },
    },
};
</script>

<style scoped>

</style>
